import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PublicMapService } from '../../../service/public-map.service';
import { MapTab } from 'src/app/common/constants';

@Component({
  selector: 'app-add-stage-group',
  templateUrl: './add-stage-group.component.html',
  styleUrls: ['./add-stage-group.component.css'],
})
export class AddStageGroupComponent implements OnInit {
  @Output() closeDialog = new EventEmitter<any>();
  name: string

  get focusOnStageGroup() {
    return this.publicMapService.focusOnStageGroup
  }

  constructor(
    private publicMapService: PublicMapService,
  ) { }

  ngOnInit(): void {
    this.name = this.publicMapService.focusOnStageGroup.name
  }

  remove(id) {
    const _stages = this.focusOnStageGroup.stages.filter((x) => x.id !== id)
    this.publicMapService.setfocusOnStageGroup({ ...this.focusOnStageGroup, stages: _stages })
  }

  submit(mode: 'create' | 'edit') {
    switch (mode) {
      case 'create':
        this.publicMapService.addItem({ data: { name: this.name, stageIds: this.focusOnStageGroup.stages.map(item => item.id) }, type: MapTab.StageGroup }).subscribe(_ => {
          this.closeDialog.emit()
        })
        break;
      case 'edit':
        const _data = { id: this.focusOnStageGroup.id, name: this.name, stageIds: this.focusOnStageGroup.stages.map(item => item.id) }
        this.publicMapService.updateItem({ data: _data, type: MapTab.StageGroup }).subscribe(_ => {
          this.closeDialog.emit()
        })
        break;
    }
  }

  cancelFocus(){
    this.publicMapService.resetFocusOnStageGroup()
    this.closeDialog.emit()
  }
}
